module.exports = __webpack_public_path__ + "img/icon-family.bd190bcf.png";